import { ErrorInfo, PureComponent } from 'react';
import { Notifier } from '@airbrake/browser';
import { Button } from 'antd';

import './styles.scss';

interface State {
  isError: boolean;
}

interface Props {
  airbrake: Notifier;
}

export class ErrorBoundary extends PureComponent<Props, State> {
  state = {
    isError: false,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { airbrake } = this.props;

    airbrake?.notify(error);
    console.error(error);
    this.setState({ isError: true });
  }

  handleError = () => {
    window.location.reload();
  };

  render() {
    const { children } = this.props;
    const { isError } = this.state;

    return isError ? (
      <div className="app-error-wrapper">
        <div className="app-error-content">
          Something went wrong
          <Button type="primary" onClick={this.handleError}>
            Reload page
          </Button>
        </div>
      </div>
    ) : (
      children
    );
  }
}
